module.exports = __webpack_public_path__ + "static/img/Churou_QIU.bd33d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Churou_QIU.png
// module id = DqU2
// module chunks = 1